<template>
    <a
        class="sg-btn sg-btn-icon"
        :class="{ 'sg-btn-icon--with-background': withBackground, active: active }"
        @click.prevent="onClick"
    >
        <span class="sg-btn-toggle-icon-icon" :class="iconClass" />
    </a>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import $ from 'jquery';
import { ngInject } from '@/vue/decorators/angular-interop';
@Component
export default class VrmIconButton extends Vue {
    @ngInject()
    $rootScope;

    @Prop()
    iconClass;
    @Prop({ type: Boolean, default: false })
    withBackground;
    @Prop({ type: Boolean, default: false })
    active;
    @Prop({ type: String, default: null })
    vrmDropdownTrigger;

    onClick(event) {
        if (this.vrmDropdownTrigger) {
            this.triggerDropdown(event);
        }

        this.$emit('click', event);
    }

    triggerDropdown(event) {
        this.$rootScope.$emit('vrmDropdownEvent.toggle', {
            id: this.vrmDropdownTrigger,
            target: $(event.target),
            eventType: event.type,
        });
    }
}
</script>
